<script lang="ts">
    import dayjs from 'dayjs';

    import MainFilters from '$saga/views/Search/MainFilters/MainFilters.svelte';
    import { filtersContext, sortValue } from '$saga/views/Search/store';
</script>

<MainFilters />

<!-- main form filters, hidden -->
<!--Desti -->
{#each $filtersContext.formValues.destination as value (value)}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="destination[]"
        {value}
    />
{/each}

<!--Sport -->
{#each $filtersContext.formValues.theme as value (value)}
    <input
        aria-hidden="true"
        tabindex="-1"
        class="hidden"
        name="theme[]"
        {value}
    />
{/each}

<!--    startDate -->
<input
    aria-hidden="true"
    tabindex="-1"
    class="hidden"
    name="startDate"
    value={$filtersContext.formValues.startDate
        ? dayjs($filtersContext.formValues.startDate.toString()).format(
              'DD/MM/YYYY',
          )
        : ''}
/>
<!--    endDate -->
<input
    aria-hidden="true"
    tabindex="-1"
    class="hidden"
    name="endDate"
    value={$filtersContext.formValues.endDate
        ? dayjs($filtersContext.formValues.endDate.toString()).format(
              'DD/MM/YYYY',
          )
        : ''}
/>

<!--    months -->
{#if $filtersContext.formValues.months.length > 0}
    {#each $filtersContext.formValues.months as month (month)}
        <input
            aria-hidden="true"
            tabindex="-1"
            class="hidden"
            name="month[]"
            value={month}
        />
    {/each}
{/if}

<input
    aria-hidden="true"
    tabindex="-1"
    class="hidden"
    name="flexibility"
    value={$filtersContext.formValues.flexibility}
/>

<input
    aria-hidden="true"
    tabindex="-1"
    class="hidden"
    name="nbPax"
    value={Number($filtersContext.formValues.nbPax)}
/>

<input
    aria-hidden="true"
    tabindex="-1"
    class="hidden"
    name="sort"
    value={$sortValue}
/>
